import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";

const  pengajuanGajiProsesService = {}

pengajuanGajiProsesService.data = function (token,data='') {
    return fetch({
        url: '/transaksi/pengajuan_gaji_proses/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

pengajuanGajiProsesService.pegawai_belum_tagihan = function (token,data='') {
    return fetch({
        url: '/transaksi/pengajuan_gaji_proses/get_pegawai_belum_tagihan',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

pengajuanGajiProsesService.hitung_pajak = function (token,data='') {
    return fetch({
        url: '/transaksi/pengajuan_gaji_proses/hitung_pajak',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

export default pengajuanGajiProsesService;
